import React from 'react';
import { fmt } from './constants';

export const SumCard = ({ label, value, highlight, danger }) => (
  <div className={`rounded-lg p-2.5 border ${highlight ? 'bg-emerald-50 border-emerald-200' : danger ? 'bg-rose-50 border-rose-200' : 'bg-slate-50 border-slate-200'}`}>
    <div className="text-[10px] uppercase tracking-wide text-slate-500">{label}</div>
    <div className={`text-sm font-semibold ${highlight ? 'text-emerald-800' : danger ? 'text-rose-800' : 'text-slate-800'}`}>{value}</div>
  </div>
);

export const CatSumRow = ({ label, data }) => {
  const exp = data.expected_pcs || 0;
  const rec = data.recovered_pcs || 0;
  const tally = exp > 0
    ? (rec === exp ? 'ok' : (rec < exp ? 'short' : 'over'))
    : null;
  const tallyClass = tally === 'ok' ? 'text-emerald-700 bg-emerald-50 border-emerald-200'
    : tally === 'short' ? 'text-rose-700 bg-rose-50 border-rose-200'
    : tally === 'over' ? 'text-amber-800 bg-amber-50 border-amber-200'
    : 'text-slate-500 bg-slate-50 border-slate-200';
  return (
    <div className="bg-white border rounded-lg px-3 py-2 text-xs">
      <div className="flex items-center gap-2 mb-1">
        <span className="font-medium flex-1">{label}</span>
        {exp > 0 && (
          <span className={`px-1.5 py-0.5 rounded border text-[10px] font-medium ${tallyClass}`}>
            {rec}/{exp} pcs {tally === 'ok' ? '✓' : tally === 'short' ? '↓' : '↑'}
          </span>
        )}
      </div>
      <div className="grid grid-cols-3 gap-1 text-[10px]">
        <span className="text-emerald-700">✓ {data.usable_pcs || 0}p · {fmt(data.usable_wt)}g</span>
        <span className="text-orange-700">⚠ {data.broken_pcs || 0}p · {fmt(data.broken_wt || 0)}g</span>
        <span className="text-rose-700">✗ {data.not_usable_pcs || 0}p · {fmt(data.not_usable_wt)}g</span>
      </div>
    </div>
  );
};

export const MiniStat = ({ label, value, tone, testid }) => {
  const tones = {
    emerald: 'bg-emerald-50  text-emerald-800 border-emerald-200',
    amber:   'bg-amber-50    text-amber-800   border-amber-200',
    rose:    'bg-rose-50     text-rose-800    border-rose-200',
  };
  return (
    <div className={`rounded-lg border py-2 ${tones[tone] || tones.emerald}`} data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wide opacity-80">{label}</div>
      <div className="text-sm font-semibold">{value}</div>
    </div>
  );
};
